import { render, staticRenderFns } from "./NewMedicationUnit.vue?vue&type=template&id=f00cec28&scoped=true"
import script from "./NewMedicationUnit.vue?vue&type=script&lang=js"
export * from "./NewMedicationUnit.vue?vue&type=script&lang=js"
import style0 from "./NewMedicationUnit.vue?vue&type=style&index=0&id=f00cec28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00cec28",
  null
  
)

export default component.exports